import { useTranslation } from "react-i18next";
import type { PublicProvider } from "../../api/publicProviders";

/**
 * The covered tools as one phrase in the reader's language ("Claude, GitHub Copilot, Cursor and Amazon Bedrock"), or "your AI tools"
 * until they are known, so copy that names the tools is never out of step with the portal.
 *
 * @param providers - The covered tools, or null when not known.
 * @returns The phrase.
 */
export function useToolList(providers: PublicProvider[] | null): string {
  const { t, i18n } = useTranslation();
  // The English copy is British, so its lists are too: "Cursor and GitHub Copilot", with no serial comma.
  const locale = i18n.language === "en" ? "en-GB" : i18n.language;
  return providers
    ? new Intl.ListFormat(locale, { style: "long", type: "conjunction" }).format(providers.map((provider) => provider.displayName))
    : t("signedOut.toolsFallback");
}
